import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { couponrequest } from '../models/Coupons/postCouponRequest.model';
import { getCouponsResponse } from '../models/Coupons/getCouponsResponse.model';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CouponService {
  private apiUrl = environment.apiUrl;
  //apiUrl = 'https://localhost:7142/api/Coupons';
  //apiUrl = 'https://arada-group.xyz/api/Coupons';


  constructor(private http: HttpClient) { }

  getAllCoupons(): Observable<getCouponsResponse[]> {
    return this.http.get<getCouponsResponse[]>(`${this.apiUrl}/Coupons?addAuth=true`).pipe(
      catchError(this.handleError)
    );
  }
  
  checkMenuItemCoupon(menuItemId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/Coupons/CheckMenuItemDiscount?menuItemId=${menuItemId}`).pipe(
      catchError(this.handleError)
    );
  }

  sendCoupon(request: couponrequest): Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/Coupons?addAuth=true`, request).pipe(
      catchError(this.handleError)
    );
  }
  deleteCoupon(id: number): Observable<any>{
    return this.http.delete<any>(`${this.apiUrl}/Coupons?id=${id}&addAuth=true`).pipe(
      catchError(this.handleError)
    );
  }

  updateStatus(id: number): Observable<any>{
    return this.http.put<any>(`${this.apiUrl}/Coupons?id=${id}&addAuth=true`, null).pipe(
      catchError(this.handleError)
    );
  }
  
  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
